module.exports = __webpack_public_path__ + "static/media/wordpress.2c7edcc6.png";